import { Column as BaseColumn } from '../../DataTable/index.jsx';


class Column extends BaseColumn {
  sortAscending(a, b) {
    if (a.title < b.title) {
      return -1;
    }
    if (a.title > b.title) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.title < b.title) {
      return 1;
    }
    if (a.title > b.title) {
      return -1;
    }
    return super.sortDescending(a, b);
  }
}


export default Column;

